// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__bmJ4C","boxTitle":"Qualiphy_boxTitle__2VAQC","box":"Qualiphy_box__1RGme","toggleWrap":"Qualiphy_toggleWrap__1Yz5H"};